import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { Link, useLocation } from "react-router-dom";

import LOGO from "assets/image/errorPage/acgnetworkerror.svg";

export default function ErrorPage() {
  const { from } = useLocation().state;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      width={"100vw"}
      height={"100vh"}
    >
      <Box
        width={"1000px"}
        height="600px"
        display="flex"
        justifyContent={"center"}
        alignItems="center"
        bgcolor={"white"}
        boxShadow={"4px 4px 60px #ccc"}
        borderRadius={2}
        bottom={0}
        margin={"auto"}
        position="relative"
      >
        <Box component={"img"} src={LOGO} pb={7} pr={7} />
        <Box position={"absolute"} bottom={60}>
          <Link to={from === "hr" ? "/login_hr" : "/login"}>
            <Button size="large" variant="contained">
              홈으로
            </Button>
          </Link>
        </Box>
        {/* </Box> */}
      </Box>
    </Grid>
  );
}
